import { render, staticRenderFns } from "./AddressBook.vue?vue&type=template&id=5cd405ca&scoped=true"
import script from "./AddressBook.vue?vue&type=script&lang=js"
export * from "./AddressBook.vue?vue&type=script&lang=js"
import style0 from "./AddressBook.vue?vue&type=style&index=0&id=5cd405ca&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd405ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd405ca')) {
      api.createRecord('5cd405ca', component.options)
    } else {
      api.reload('5cd405ca', component.options)
    }
    module.hot.accept("./AddressBook.vue?vue&type=template&id=5cd405ca&scoped=true", function () {
      api.rerender('5cd405ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/addressBook/AddressBook.vue"
export default component.exports